export const digitalProductPassport = {
  digitalProductPassport: "Digital Product Passport",
  batteryPassport: "Battery Passport",
};
